import { posthogWeb } from "src/integrations/posthog/client-web"
import { TrackingLineItem, TrackingOrder } from "src/tracking/types"
import { roundPrice } from "src/utilities/price"

export type PostHogEventProperties = NonNullable<Parameters<typeof posthogWeb.capture>[1]>

// https://posthog.com/docs/data/event-spec/ecommerce-events#product-added
export function mapToPosthogLineItem(item: TrackingLineItem): PostHogEventProperties {
  return {
    product_id: item.id,
    sku: item.sku,
    category: item.categories?.join(",") || null,
    name: item.name,
    brand: "elvent",
    variant: item.variantName || null,
    price: item.netFullPrice,
    quantity: item.quantity,
    coupon: item.discountCodes.join(","),
    // position: 3, // TODO Add position in the product list
    url: item.href,
    image_url: item.image,
  }
}

// https://posthog.com/docs/data/event-spec/ecommerce-events#order-completed
export function mapToPosthogOrder(order: TrackingOrder): PostHogEventProperties {
  return {
    order_id: order.transactionId,
    affiliation: "elvent.shop",
    subtotal: order.netValue,
    total: order.grossValue,
    revenue: roundPrice(order.netValue + order.discount),
    shipping: order.netShipping,
    tax: order.totalTax,
    discount: order.discount,
    coupon: order.discountCodes.join(","),
    currency: order.currencyCode,
    products: order.items.map(mapToPosthogLineItem),
  }
}
